import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Search } from "semantic-ui-react";
import { SearchProps, SearchResultData } from "semantic-ui-react/dist/commonjs/modules/Search/Search";
import { SearchNetworkByName } from "../../services/NetworkApi";
import useAuth from "../login/AuthContext";
import { IdNameTransport } from "../../services/Common";

interface NetworkSearchProps {
  setNetwork: (id: number) => void;
}

const SearchHolder = styled.div`
  padding: 10px;
  float: left;
`;

interface NetworkSearchState {
  loading: boolean;
  search: string;
  results: IdNameTransport[];
}

export const NetworkSearch: React.FunctionComponent<NetworkSearchProps> = ({ setNetwork }) => {
  const { getAuthToken } = useAuth();
  const [state, setState] = useState<NetworkSearchState>({
    loading: false,
    search: "",
    results: [],
  });

  useEffect(() => {
    if (state.search.length < 3) {
      return;
    }

    const handler = setTimeout(async () => {
      setState({ ...state, loading: true });
      const results = await SearchNetworkByName(state.search, await getAuthToken());

      if (results) {
        setState({ ...state, loading: false, results });
      } else {
        setState({ ...state, loading: false, results: [] });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [state.search]);

  return (
    <SearchHolder>
      <Search
        loading={state.loading}
        results={state.results.map((x) => ({ title: x.name, id: x.id }))}
        onResultSelect={(event: React.MouseEvent<HTMLDivElement>, data: SearchResultData) => {
          setNetwork(data.result.id);
        }}
        onSearchChange={(event: React.MouseEvent<HTMLElement>, data: SearchProps) => {
          if (data.value) {
            setState({ ...state, search: data.value });
          }
        }}
      />
    </SearchHolder>
  );
};
